<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4NJwmx/tc-custom/9783965373181.jpg?1703042207915" alt="This image is the cover for the book Vom Kriege, The World At War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vom Kriege, The World At War
      </h1>
      <p class="bookDescription body article font2">
        <p>Die Formel, der Krieg sei die Fortsetzung der Politik mit anderen oder zusätzlichen Mitteln, führt weiter als die banalen Bemerkungen über die Verbindung von Politik und Krieg. Clausewitz entwickelt die Idee in zwei Richtungen: Die Führung des Krieges liegt bei der politischen Macht und nicht bei den Führern der Armee.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carl von Clausewitz
      </h2>
      
      <p class="authorDescription body article">Carl Philipp Gottlieb von Clausewitz (* 1. Juli 1780 als Carl Philipp Gottlieb Clauswitz in Burg; † 16. November 1831 in Breslau) war ein preußischer Generalmajor, Heeresreformer, Militärwissenschaftler und -ethiker. Clausewitz wurde durch sein unvollendetes Hauptwerk Vom Kriege bekannt, das sich mit der Theorie des Krieges beschäftigt. Seine Theorien über Strategie, Taktik und Philosophie hatten großen Einfluss auf die Entwicklung des Kriegswesens in allen westlichen Ländern und werden bis heute an Militärakademien gelehrt. Sie finden auch im Bereich der Unternehmensführung sowie im Marketing Anwendung.(Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTBebook Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a5cd9b7